<template>
  <select @change="switchLanguage">
    <option
      v-for="sLocale in supportedLocales"
      :key="`locale-${sLocale}`"
      :value="sLocale"
       :selected="currentLocale === sLocale"
    >
      {{  $t(`locale.${sLocale}`) }}
    </option>
  </select>
</template>

<script>
  import { useRouter } from "vue-router"
  import Tr from "@/i18n/translation"

  export default {
    setup() {
      const supportedLocales = Tr.supportedLocales
      const currentLocale = Tr.currentLocale

      const router = useRouter()

      const switchLanguage = async (event) => {
        const newLocale = event.target.value

        await Tr.switchLanguage(newLocale)

        try {
          await router.replace({ params: { locale: newLocale } })
        } catch(e) {
          console.log(e)
          router.push("/")
        }
      }

      return { supportedLocales, switchLanguage, currentLocale }
    }
  }
</script>